export function getTitle(title?: string) {
  const breadcrumbsText = title?.split(">") || [];
  const titleText = breadcrumbsText.pop()?.trim() || "";
  return titleText;
}
